"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayerByPriority = void 0;
function getLayerByPriority(opening, layerOrLayers) {
    if (Array.isArray(layerOrLayers)) {
        // An array of strings means find the first one that is defined.
        const layerNameToUse = layerOrLayers.find(layerName => opening.layout[layerName]);
        return layerNameToUse ? opening.layout[layerNameToUse] : null;
    }
    else if (typeof layerOrLayers === "string") {
        // A single string means use that layer
        return opening.layout[layerOrLayers];
    }
    else {
        // An SVG node means use that node.
        return layerOrLayers;
    }
}
exports.getLayerByPriority = getLayerByPriority;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3BlbmluZ1V0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvb3BlbmluZy9vcGVuaW5nVXRpbHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUlBLFNBQWdCLGtCQUFrQixDQUNoQyxPQUF1QixFQUN2QixhQUFzQztJQUV0QyxJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDLEVBQUU7UUFDaEMsZ0VBQWdFO1FBQ2hFLE1BQU0sY0FBYyxHQUFHLGFBQWEsQ0FBQyxJQUFJLENBQ3ZDLFNBQVMsQ0FBQyxFQUFFLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxTQUFTLENBQUMsQ0FDdkMsQ0FBQztRQUNGLE9BQU8sY0FBYyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7S0FDL0Q7U0FBTSxJQUFJLE9BQU8sYUFBYSxLQUFLLFFBQVEsRUFBRTtRQUM1Qyx1Q0FBdUM7UUFDdkMsT0FBTyxPQUFPLENBQUMsTUFBTSxDQUFDLGFBQWEsQ0FBQyxDQUFDO0tBQ3RDO1NBQU07UUFDTCxtQ0FBbUM7UUFDbkMsT0FBTyxhQUFhLENBQUM7S0FDdEI7QUFDSCxDQUFDO0FBakJELGdEQWlCQyJ9